// src/polaris-components/SubscriptionCancel.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/subscription-result.css';

export const SubscriptionCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="subscription-result-container" data-testid="subscription-cancel">
      <div className="result-card cancel-card">
        <div className="result-icon cancel-icon">✕</div>
        <h1>Checkout Cancelled</h1>
        <p className="result-message">
          No worries! Your checkout was cancelled and no charges were made.
        </p>

        <div className="reasons-section">
          <h2>Changed your mind?</h2>
          <p>We understand! Here's what you might want to consider:</p>
          <ul>
            <li><strong>Free Trial:</strong> All plans include a 14-day free trial</li>
            <li><strong>Cancel Anytime:</strong> No commitments or cancellation fees</li>
            <li><strong>Premium Features:</strong> Access exclusive college planning tools</li>
            <li><strong>Expert Guidance:</strong> Get personalized advice from college counselors</li>
          </ul>
        </div>

        <div className="alternative-options">
          <h2>Need Help?</h2>
          <p>
            If you have questions about our plans or features, our support team is here to help.
          </p>
          <a href="mailto:support@polarisathlete.com" className="support-link">
            Contact Support →
          </a>
        </div>

        <div className="result-actions">
          <button
            onClick={() => navigate('/signup')}
            className="result-btn primary-btn"
            data-testid="try-again-btn"
          >
            View Plans Again
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="result-btn secondary-btn"
            data-testid="back-dashboard-btn"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};
